export default __webpack_public_path__ + "static/media/iPhone.4d0623f4.png";